import React from "react";
import { useSnapshot } from "valtio";
import { wizardStore } from "../../stores/wizard";
import { isStepHiddenByRules } from "../../config/productRules";

interface TopProgressBarProps {
  className?: string;
}

export const TopProgressBar: React.FC<TopProgressBarProps> = ({
  className = ""
}) => {
  const wizSnap = useSnapshot(wizardStore);
  const productType = wizSnap?.emblemData?.ProductType;
  const productSubtype = wizSnap?.emblemData?.ProductSubtype;

  const hasRequiredInitialSteps =
    productType !== undefined &&
    productType !== null &&
    productType !== '' &&
    productSubtype !== undefined &&
    productSubtype !== null &&
    productSubtype !== '';

  if (!hasRequiredInitialSteps) {
    return null;
  }

  const validSteps = wizSnap?.steps?.filter(step => {
    if (step.id === 'RequestDetails') return false;
    if (isStepHiddenByRules(step.id, wizSnap.emblemData)) return false;
    return true;
  });

  const completedSteps = validSteps.filter(step => {
    const stepData = wizSnap?.emblemData[step.id];
    const hasData = stepData !== undefined && stepData !== null && stepData !== '';
    const hasErrors = wizSnap?.errors[step.id] && wizSnap?.errors[step.id].length > 0;

    return hasData && !hasErrors;
  });

  const totalSteps = validSteps.length;
  const completedCount = completedSteps.length;
  const progressPercentage = totalSteps > 0 ? (completedCount / totalSteps) * 100 : 0;

  return (
    <div className={`w-full h-[6px] bg-gray-200 ${className}`}>
      <div
        className="h-full bg-gradient-to-r from-orange-500 to-orange-600 transition-all duration-700 ease-out"
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  );
};